"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBInput = _interopRequireDefault(require("../HBInput/HBInput"));
var _HBTagNew = _interopRequireDefault(require("../HBTagNew/HBTagNew"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _HBMemberTag = _interopRequireDefault(require("../HBMemberTag/HBMemberTag"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// if/when we want to add a side panel for extra filters.
// import Filter16 from '@honeybook/icons/dist/icons/Filter16';
// const MAX_FILTERS_TO_SHOW = 4;

function HBTableFilters(_ref) {
  var table = _ref.table;
  var _table$options$meta = table.options.meta,
    isLoading = _table$options$meta.isLoading,
    search = _table$options$meta.search,
    setSearch = _table$options$meta.setSearch,
    filterElements = _table$options$meta.filterElements,
    allFilterLabels = _table$options$meta.allFilterLabels,
    clearAllFilters = _table$options$meta.clearAllFilters;

  // const hasMoreThanMax = filterElements?.length > MAX_FILTERS_TO_SHOW;
  // const filtersToShow = hasMoreThanMax
  //     ? filterElements?.slice(0, MAX_FILTERS_TO_SHOW - 1)
  //     : filterElements;

  return /*#__PURE__*/_react["default"].createElement(Container, null, (filterElements || !!search) && /*#__PURE__*/_react["default"].createElement(TopContainer, null, /*#__PURE__*/_react["default"].createElement(TopLeftSideContainer, null, filterElements), /*#__PURE__*/_react["default"].createElement(TopRightSideContainer, null, search != null && /*#__PURE__*/_react["default"].createElement(_HBInput["default"], {
    size: "sm",
    placeholder: "Search",
    testIdName: "search",
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    }
  }))), (allFilterLabels === null || allFilterLabels === void 0 ? void 0 : allFilterLabels.length) > 0 && /*#__PURE__*/_react["default"].createElement(AllFilterTagsContainer, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textSecondary"
  }, "Filtered by"), allFilterLabels.map(function (filter) {
    var props = _objectSpread(_objectSpread({}, filter), {}, {
      size: 'sm',
      key: filter.label
    });
    return filter.color ? /*#__PURE__*/_react["default"].createElement(_HBMemberTag["default"], (0, _extends2["default"])({
      color: filter.color
    }, props)) : /*#__PURE__*/_react["default"].createElement(_HBTagNew["default"], props);
  }), /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], {
    size: "sm",
    onClick: clearAllFilters,
    linkButtonTheme: "solid",
    testIdName: "clear-all-filters"
  }, "Clear all")), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textSecondary",
    ellipsis: true,
    testId: "".concat(table.options.meta.testIdPrefix, "-total-count")
  }, isLoading ? 'Loading...' : "".concat(table.getRowCount(), " items")));
}
var _default = exports["default"] = HBTableFilters; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFilters__Container",
  componentId: "sc-lfp4pa-0"
})(["padding:16px;border-bottom:1px solid ", ";display:flex;flex-direction:column;gap:16px;background-color:", ";border-top-right-radius:inherit;border-top-left-radius:inherit;"], _colors["default"].neutral300, _colors["default"].white);
var TopContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFilters__TopContainer",
  componentId: "sc-lfp4pa-1"
})(["display:flex;align-items:flex-start;justify-content:space-between;gap:16px;"]);
var TopLeftSideContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFilters__TopLeftSideContainer",
  componentId: "sc-lfp4pa-2"
})(["display:flex;align-items:center;flex-wrap:wrap;flex-grow:1;gap:8px 12px;> *{max-width:200px;}"]);
var TopRightSideContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFilters__TopRightSideContainer",
  componentId: "sc-lfp4pa-3"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:16px;"]);
var AllFilterTagsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFilters__AllFilterTagsContainer",
  componentId: "sc-lfp4pa-4"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:8px;"]);
//# sourceMappingURL=HBTableFilters.js.map